import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=4056174f&lang=pug&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports